<template>
  <v-container class="test_red">
    <v-row justify="center" no-gutters class="test_blue">
      <v-col cols="12" class="test_yellow">
        <v-data-table
          :headers="headers"
          :items="items"
          :options.sync="options"
          :server-items-length="totalItems"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :loading="$store.getters.isLoading"
          loader-height="3"
          dense
          class="elevation-0 table-pointer pa-5"
          :single-select="true"
          :item-class="itemRowBackground"
          @click:row="selectRow"
        >
          <template v-slot:top>
            <v-container fluid>
              <v-row>
                <v-col cols="6" sm="4" md="3" lg="4" class="test_red">
                  <datatable-search
                    v-model="filters.search"
                    :label="$t('customerProfile.searchByReference')"
                    class="search-input"
                    @click="loadOrders()"
                  />
                </v-col>
              </v-row>
            </v-container>
          </template>

          <template v-slot:[`item.orderCreatedTime`]="{ item }">
            <span
              v-text="$appFormatters.formatDateRead(item.orderCreatedTime)"
            />
          </template>
          <template v-slot:[`item.publicRef`]="{ item }">
            <span v-text="'#' + item.publicRef" />
          </template>
          <template v-slot:[`item.service`]="{ item }">
            <v-icon small v-text="item.service.icon" />
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-dialog
      v-if="showDialog"
      v-model="showDialog"
      max-width="400"
      transition="dialog-bottom-transition"
      content-class="dialog-rounded"
      :scrollable="true"
    >
      <ReceiptPdf :datas="datas" />
    </v-dialog>
  </v-container>
</template>

<script>
import { ReceiptPdf } from "../../thanks/components";
export default {
  name: "OrderHistory",
  components: {
    ReceiptPdf,
  },
  data: () => ({
    showDialog: false,
    today: new Date().toISOString().substr(0, 10),
    selectedId: null,
    datas: null,
    headers: [
      {
        text: "Created",
        value: "orderCreatedTime",
        data: "orderCreatedTime",
        align: "left",
        sortable: false,
        searchable: false,
        orderable: false,
      },
      {
        text: "Reference",
        value: "publicRef",
        data: "public_ref",
        align: "center",
        sortable: false,
        searchable: true,
        orderable: false,
      },
      {
        text: "Destination",
        value: "destinationPrettyAddress",
        data: "u_pretty_address",
        align: "center",
        sortable: false,
        searchable: true,
        orderable: false,
      },
      {
        text: "Service",
        value: "service",
        data: "service.id",
        align: "center",
        sortable: false,
        searchable: false,
        orderable: false,
      },
      {
        text: "Payment",
        value: "paymentType",
        data: "paymentType.name",
        align: "center",
        sortable: false,
        searchable: false,
        orderable: false,
      },
      {
        text: "Status",
        value: "customerOrderStatus",
        data: "customerOrderStatus",
        align: "center",
        sortable: false,
        searchable: false,
        orderable: false,
      },
    ],
    sortBy: "",
    sortDesc: true,
    options: {},
    items: [],
    totalItems: 0,
    filters: {
      search: null,
    },
  }),
  watch: {
    options: {
      handler() {
        this.loadOrders();
      },
      deep: true,
    },
    filters: {
      handler() {
        this.loadOrders();
      },
      deep: true,
    },
    showDialog: function () {
      if (!this.showDialog) {
        this.selectedId = null;
      }
    },
  },
  methods: {
    loadOrders: async function () {
      const self = this;
      self.$store.dispatch("loading/start");
      let params = {
        columns: self.headers,
        search: self.filters.search,
      };
      const { data } = await axios.get(
        "/users/profiles/orders/history",
        self.$datatables.paramsSerializerDatatables(params, this.options)
      );
      self.items = data.data;
      self.totalItems = data.recordsTotal;

      setTimeout(() => {
        self.$store.dispatch("loading/done");
      }, 1000);
    },
    selectRow: async function (value) {
      const self = this;
      if (value.id === self.selectedId) {
        self.showDialog = false;
        self.datas = null;
      } else {
        self.selectedId = value.id;
        self.datas = value;
        self.showDialog = true;
      }
    },
    itemRowBackground: function (item) {
      return item.id == this.selectedId ? "v-data-table__selected" : "";
    },
  },
};
</script>
